import { LitElement, html, css } from "lit";
/**
 * A component for single navigation links
 *
 * @element ds-singlenav
 * @prop {string} type - Type of navigation: "projects" or "work"
 * @prop {string} to - Optional custom destination URL
 */
export class SingleNav extends LitElement {
    static get properties() {
        return {
            type: { type: String, reflect: true },
            to: { type: String, reflect: true },
        };
    }
    constructor() {
        super();
        this.type = "work";
    }
    render() {
        const navConfig = this.getNavConfig();
        const href = this.to || navConfig.href;
        return html `
      <a href="${href}">
        <ds-text key="${navConfig.key}"></ds-text>
        <ds-icon type="right"></ds-icon>
      </a>
    `;
    }
    getNavConfig() {
        switch (this.type) {
            case "projects":
                return {
                    href: "/projects",
                    key: "projects",
                };
            case "work":
                return {
                    href: "/",
                    key: "workExperience",
                };
        }
    }
}
SingleNav.styles = css `
    :host {
      display: flex;
      justify-content: end;
      gap: calc(5px * var(--scaling-factor));
      padding: calc(2px * var(--scaling-factor));
      align-items: center;
    }

    a {
      display: inline-flex;
      align-items: center;
      gap: calc(5px * var(--scaling-factor));
      text-decoration: none;
      color: inherit;
    }
  `;
customElements.define("ds-singlenav", SingleNav);
